import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { truthy, fmtDate } from './helpers';

export const HistoryTimeline: React.FC<{ loading: boolean; rows: any[] }> = ({ loading, rows }) => {
  if (loading) return <Skeleton className="h-40 w-full" />;
  if (rows.length === 0)
    return <p className="py-8 text-center text-sm text-gray-400">No history recorded.</p>;

  const stateChips = (h: any) => {
    const flags: [string, unknown, string][] = [
      ['Published', h.published, 'bg-emerald-50 text-emerald-700'],
      ['Active', h.active, 'bg-blue-50 text-blue-700'],
      ['Review', h.review, 'bg-amber-50 text-amber-700'],
      ['Rejected', h.rejected, 'bg-rose-50 text-rose-700'],
      ['Verified', h.verified, 'bg-indigo-50 text-indigo-700'],
      ['Archived', h.archive, 'bg-gray-100 text-gray-600'],
      ['Deleted', h.deleted, 'bg-red-50 text-red-700'],
    ];
    const on = flags.filter(([, v]) => truthy(v));
    if (on.length === 0)
      return <span className="text-xs text-gray-400">no active flags</span>;
    return on.map(([label, , cls]) => (
      <span key={label} className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${cls}`}>
        {label}
      </span>
    ));
  };

  return (
    <ol className="relative space-y-4 border-l-2 border-gray-100 pl-6">
      {rows.map((h, i) => (
        <li key={h.id ?? i} className="relative">
          <span className="absolute -left-[31px] top-1 h-3 w-3 rounded-full border-2 border-white bg-indigo-500 ring-1 ring-indigo-200" />
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-sm font-medium text-gray-900">
              {fmtDate(h.date_modified || h.date_added)}
            </p>
            {(h.name_basic || h.name) && (
              <p className="truncate text-xs text-gray-400">{h.name_basic || h.name}</p>
            )}
          </div>
          <div className="mt-1.5 flex flex-wrap gap-1.5">{stateChips(h)}</div>
        </li>
      ))}
    </ol>
  );
};
